// extracted by mini-css-extract-plugin
export var numpadContainer = "_hz-1";
export var phoneButton = "_hz-0";